import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CATEGORY_COLORS, tint } from './utils';

const Badge = styled.span`
  display: inline-block;
  padding: 2px 7px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  background: ${({ badgeColor }) => tint(badgeColor, 10)};
  border: 1px solid ${({ badgeColor }) => tint(badgeColor, 20)};
  color: ${({ badgeColor }) => badgeColor};
`;

export default function CategoryBadge({ category }) {
  const badgeColor = CATEGORY_COLORS[category] || 'var(--if-accent)';

  return <Badge badgeColor={badgeColor}>{category}</Badge>;
}

CategoryBadge.propTypes = {
  category: PropTypes.string.isRequired,
};
